import { useState, useEffect } from 'preact/hooks';
import { getSizedImageUrl } from '../../core/shopify/get-sized-image-url';
const SRCSET_WIDTHS = [
    300,
    600,
    1000
];
export const useGiftboxImage = ({ giftboxKey , selectedVariantId , giftboxProducts , diyGiftboxProducts , defaultImage =null , defaultAlt =''  })=>{
    const [src, setSrc] = useState(defaultImage);
    const [alt, setAlt] = useState(defaultAlt);
    useEffect(()=>{
        try {
            if (giftboxKey) {
                const product = giftboxProducts && giftboxProducts[giftboxKey] || diyGiftboxProducts && diyGiftboxProducts[giftboxKey] || null;
                if (product) {
                    const variant = Array.isArray(product.variants) ? product.variants.find((v)=>String(v.id) === String(selectedVariantId)) : null;
                    const image = (variant === null || variant === void 0 ? void 0 : variant.featuredImage) || (variant === null || variant === void 0 ? void 0 : variant.smallImage) || product.featuredImage || product.image || defaultImage;
                    setSrc(image);
                    setAlt((variant === null || variant === void 0 ? void 0 : variant.title) || product.featuredImageAlt || product.title || '');
                    return;
                }
            }
        } catch (err) {
        // ignore
        }
        setSrc(defaultImage);
        setAlt(defaultAlt);
    }, [
        giftboxKey,
        selectedVariantId,
        giftboxProducts,
        diyGiftboxProducts,
        defaultImage,
        defaultAlt
    ]);
    const srcset = src ? SRCSET_WIDTHS.map((w)=>`${getSizedImageUrl(src, `${w}x`)} ${w}w`).join(', ') : undefined;
    return {
        src,
        srcset,
        alt
    };
};
